'use strict';

module.exports = {
  ISO_FIRST_DAY_OF_WEEK: 1,
  ISO_FIRST_DAY_OF_WEEK_YEAR: 4
};


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/var/ISODefaults.js
// module id = 62
// module chunks = 1